import { FormControl } from '@angular/forms';
import { getObjectProperty } from '../functions';

//======================================
// FORM CONTROL VALIDATORS
//======================================

export const NoWhitespaceValidator = (control: FormControl) => {
  return (typeof control.value === 'object' && control.value) ||
    !(!control || (control.value || '').trim().length === 0)
    ? null
    : {
        whitespace: {
          valid: false
        }
      };
};

//======================================
// FORM MODEL VALIDATORS
//======================================

export const Validators = {
  required: (formValue, fieldName, value, fieldLabel, customMsg) => {
    return {
      msg: customMsg || `El campo ${fieldLabel || fieldName} es requerido`,
      valid:
        value != null &&
        value != undefined &&
        (typeof value != 'string' || value.trim().length > 0) &&
        (!Array.isArray(value) || value.length > 0)
    };
  },

  minLength: min => (formValue, fieldName, value, fieldLabel, customMsg) => {
    const tipoCantidad = Array.isArray(value) ? 'elementos' : 'caracteres';
    return {
      msg: (
        customMsg ||
        `El campo ${fieldLabel ||
          fieldName} debe tener al menos :min ${tipoCantidad}`
      ).replace(':min', min),
      valid: !value || value.length >= min
    };
  },

  maxLength: max => (formValue, fieldName, value, fieldLabel, customMsg) => {
    const tipoCantidad = Array.isArray(value) ? 'elementos' : 'caracteres';
    return {
      msg: (
        customMsg ||
        `El campo ${fieldLabel ||
          fieldName} debe tener como máximo :max ${tipoCantidad}`
      ).replace(':max', max),
      valid: !value || value.length <= max
    };
  },

  requiredIf: (data: any) => (
    formValue,
    fieldName,
    value,
    fieldLabel,
    customMsg
  ) => {
    const requiredValidation = Validators.required(
      formValue,
      fieldName,
      value,
      fieldLabel,
      customMsg
    );

    let fields = [];

    Object.keys(data).forEach(k => {
      fields.push({ fieldName: k, value: data[k] });
    });

    const applyCondition =
      fields.filter(x => {
        if (!x.value) {
          return (
            getObjectProperty(formValue, x.fieldName) != x.value &&
            getObjectProperty(formValue, x.fieldName) != ''
          );
        }
        return getObjectProperty(formValue, x.fieldName) != x.value;
      }).length == 0;

    return {
      msg: requiredValidation.msg,
      valid: !applyCondition || requiredValidation.valid
    };
  },

  requiredUnless: (data: any) => (
    formValue,
    fieldName,
    value,
    fieldLabel,
    customMsg
  ) => {
    const requiredValidation = Validators.requiredIf(data)(
      formValue,
      fieldName,
      value,
      fieldLabel,
      customMsg
    );

    return {
      msg: requiredValidation.msg,
      valid: !requiredValidation.valid
    };
  },

  requiredWith: (fields: any[]) => (
    formValue,
    fieldName,
    value,
    fieldLabel,
    customMsg
  ) => {
    const requiredValidation = Validators.required(
      formValue,
      fieldName,
      value,
      fieldLabel,
      customMsg
    );
    //Requerido cuando al menos un campo no está lleno
    const applyCondition =
      fields.filter(
        field =>
          Validators.required(formValue, field, formValue[field], null, null)
            .valid
      ).length > 0;

    return {
      msg: requiredValidation.msg,
      valid: !applyCondition || requiredValidation.valid
    };
  },

  requiredWithAll: (fields: any[]) => (
    formValue,
    fieldName,
    value,
    fieldLabel,
    customMsg
  ) => {
    const requiredValidation = Validators.required(
      formValue,
      fieldName,
      value,
      fieldLabel,
      customMsg
    );

    //Requerido cuando todos los campos están llenos
    const applyCondition =
      fields.filter(
        field =>
          Validators.required(formValue, field, formValue[field], null, null)
            .valid
      ).length == fields.length;

    return {
      msg: requiredValidation.msg,
      valid: !applyCondition || requiredValidation.valid
    };
  },

  requiredWithout: (fields: any[]) => (
    formValue,
    fieldName,
    value,
    fieldLabel,
    customMsg
  ) => {
    const requiredValidation = Validators.required(
      formValue,
      fieldName,
      value,
      fieldLabel,
      customMsg
    );

    //requerido si al menos uno de los campos está vacío
    const applyCondition =
      fields.filter(
        field =>
          !Validators.required(formValue, field, formValue[field], null, null)
            .valid
      ).length > 0;

    return {
      msg: requiredValidation.msg,
      valid: !applyCondition || requiredValidation.valid
    };
  },

  requiredWithoutAll: (fields: any[]) => (
    formValue,
    fieldName,
    value,
    fieldLabel,
    customMsg
  ) => {
    const requiredValidation = Validators.required(
      formValue,
      fieldName,
      value,
      fieldLabel,
      customMsg
    );
    //requerido solo cuando todos los campos están vacíos
    const applyCondition =
      fields.filter(
        field =>
          Validators.required(formValue, field, formValue[field], null, null)
            .valid
      ).length == 0;

    return {
      msg: requiredValidation.msg,
      valid: !applyCondition || requiredValidation.valid
    };
  },

  email: (formValue, fieldName, value, fieldLabel, customMsg) => {
    const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    return {
      msg:
        customMsg ||
        `El campo ${fieldLabel || fieldName} no es un email válido`,
      valid: emailPattern.test(value)
    };
  },

  greaterThan: min => (formValue, fieldName, value, fieldLabel, customMsg) => {
    return {
      msg: (
        customMsg ||
        `El campo ${fieldLabel ||
          fieldName} debe ser mayor a :min`
      ).replace(':min', min),
      valid: !value || Number(value) > Number(min)
    };
  },

  greaterOrEqualThan: min => (formValue, fieldName, value, fieldLabel, customMsg) => {
    return {
      msg: (
        customMsg ||
        `El campo ${fieldLabel ||
          fieldName} debe ser mayor o igual a :min`
      ).replace(':min', min),
      valid: !value || Number(value) >= Number(min)
    };
  },
};
